document.addEventListener("click", (e) => {
  const productGrid = document.querySelector(".collection ul");
  const singleBtn = e.target.closest(".single-column-button");
  const doubleBtn = e.target.closest(".double-column-button");
  const gridBtns = document.querySelectorAll(".grid-button");

  if (!productGrid) return;

  if (singleBtn) {
    productGrid.classList.remove("grid--2-col-tablet-down");
    productGrid.classList.add("grid--1-col-tablet-down");

    localStorage.setItem('selectedProductGrid', '1');

    gridBtns.forEach(btn => btn.classList.remove("active"));
    singleBtn.classList.add("active");
  }

  if (doubleBtn) {
    productGrid.classList.remove("grid--1-col-tablet-down");
    productGrid.classList.add("grid--2-col-tablet-down");

    localStorage.setItem('selectedProductGrid', '2');

    gridBtns.forEach(btn => btn.classList.remove("active"));
    doubleBtn.classList.add("active");
  }
});
